import React from 'react';
type KeyValues = (typeof keys)[number];
type GridStyles = Record<string, string>;
export const gridGlobalStyles = "g98ghm7";
const GridGlobalStyles = () => <div className={gridGlobalStyles} />;
export default GridGlobalStyles;

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");